<template>
  <IconSvgBase :class="$style.icon" :view-width="32" :view-height="32">
    <path
      :class="$style.icon__path"
      d="M7.35183 21.3331L8.92516 19.7571C9.42916 19.2531 9.70649 18.5838 9.70649 17.8718V11.6358C9.70649 9.82645 10.4932 8.09711 11.8665 6.89444C13.2505 5.68111 15.0132 5.14778 16.8492 5.38911C19.9518 5.80111 22.2918 8.60644 22.2918 11.9158V17.8718C22.2918 18.5838 22.5692 19.2531 23.0718 19.7558L24.6465 21.3331H7.35183ZM18.6652 24.4544C18.6652 25.6531 17.4438 26.6664 15.9985 26.6664C14.5532 26.6664 13.3318 25.6531 13.3318 24.4544V23.9998H18.6652V24.4544ZM27.3598 20.2771L24.9585 17.8718V11.9158C24.9585 7.27444 21.6225 3.33178 17.1985 2.74644C14.6358 2.40511 12.0492 3.18778 10.1092 4.88911C8.15716 6.59844 7.03983 9.05711 7.03983 11.6358L7.03849 17.8718L4.63716 20.2771C4.01183 20.9038 3.82649 21.8358 4.16516 22.6531C4.50516 23.4718 5.29583 23.9998 6.18116 23.9998H10.6652V24.4544C10.6652 27.1451 13.0572 29.3331 15.9985 29.3331C18.9398 29.3331 21.3318 27.1451 21.3318 24.4544V23.9998H25.8158C26.7012 23.9998 27.4905 23.4718 27.8292 22.6544C28.1692 21.8358 27.9852 20.9024 27.3598 20.2771Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconBell',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;

  &__path {
    color: inherit;
    fill: currentcolor;
  }
}
</style>
